// extracted by mini-css-extract-plugin
export var columnList = "_ei-0";